// extracted by mini-css-extract-plugin
export var header = "glossary-search-module--header--EDl9K";